import React, { useState, useEffect } from "react";
import api from "../Services/api";
import PageDescriptionFootnote from "../PageDescription/Footnote";
import { Helmet } from "react-helmet";

const NoticiaDetalhes = (props: any) => {

    const [page, setNoticias] = useState<any>();
    var noticiaId = window.location.toString().split('Id=')[1];

    useEffect(() => {
        api.get(`ObterNoticiasDetalhada?Id=${noticiaId}`)
            .then((response) => {
                var noticia = response.data.results.find(function (n: any) { return n.Id.toString() === noticiaId; });
                console.log(noticia)
                setNoticias(noticia);
                window.scrollTo(0, 0);
            })
            .catch((err) => {
                throw new Error(err);
            });
    }, [noticiaId]);

    function formatDateAno(dateUtc: any) {
        if (dateUtc) {
            return new Date(dateUtc).getDate() + ' de ' + new Date(dateUtc).toLocaleString('pt-BR', { month: 'long' }).toString() + ' de '
                + new Date(dateUtc).getFullYear().toString();
        }
    }

    return (
        <main>
            <Helmet>               

                {/* <!-- Twitter --> */}
                <meta property="twitter:description" content={page?.Resumo}></meta>
                <meta property="twitter:card" content="summary_large_image"></meta>
                <meta property="twitter:title" content={page?.Title}></meta>
                <meta property="twitter:image" content={page?.UrlImagem}></meta>

                {/* <!-- Open Graph --> */}
                <meta property="og:title" content={page?.Title} />
                <meta property="og:image" itemProp="image" content={page?.UrlImagem} />
                <meta property="og:description" content={page?.Resumo} />
                <meta property="og:image:secure_url" content={page?.UrlImagem} />
                <meta property="ia:markup_url" content={window.location.toString()}></meta>
                <meta property="og:type" content="article"></meta>
                <meta property="og:locale" content="pt_BR"></meta>
                <meta property="og:site_name" content="FORLUZ - Plano A"></meta>
                {/* <meta property="og:image:type" content="image/jpeg" />
                    <meta property="og:image:width" content="500" />
                    <meta property="og:image:height" content="400" />*/}


            </Helmet>
            <section className={`page-banner text-white position-relative`}>
                <img src={page && page?.UrlImagem} alt="" className="d-lg-block"></img>

                <div className='overlay'></div>
                {
                    page &&
                    <div className='container h-100'>
                        <div className='row h-100 align-items-center'>
                            <div className='col-md-8 col-lg-8 col-xl-7 mt-lg-10 pr-7 pr-md-0'>

                                <p className="text-uppercase">{page?.Categoria?.Title}</p>
                                <h2>{page.Title}</h2>
                                <span className="d-block mt-4"> {formatDateAno(page.DataInicio)} </span>

                            </div>
                        </div>
                    </div>
                }
            </section>
            {/* <!-- Page description --> */}
            <div className="page-description mb-9">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="page-description__desc mb-7 mb-lg-9">
                                <p>
                                    {page?.Descricao}
                                </p>
                            </div>
                            <div className="page-description__midias">
                                <PageDescriptionFootnote title={page?.Title} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
};

export default NoticiaDetalhes;